module.exports = "#version 300 es\nprecision highp float;\n\n// The vertex shader used to render the background of the scene\n\nin vec4 vs_Pos;\nout vec2 fs_Pos;\n\nvoid main() {\n  fs_Pos = vs_Pos.xy;\n  gl_Position = vs_Pos;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/flat-vert.glsl
// module id = 68
// module chunks = 0